import type { Answers } from '@/pages/home/types';
import type { Evaluation } from '@/pages/home/utils/evaluate';

const TEXT_KEYS = [
  'age',
  'body',
  'menstrual',
  'last_period',
  'cycle_change',
  'flow_change',
  'period_color',
  'exam_date',
  'fsh',
  'e2',
  'lipid',
  'bone',
  'breast',
  'uterus',
  'thyroid',
  'surgery',
  'hrt',
  'meds',
  'allergy',
  'sym_hot_flash',
  'sym_night_sweat',
  'sym_insomnia',
  'sym_palpitation',
  'sym_mood',
  'sym_anxiety',
  'sym_fatigue',
  'sym_memory',
  'sym_joint',
  'sym_dizzy',
  'sym_dryness',
  'sym_skin',
  'top_symptoms',
  'concern',
  'contact',
] as const;

const ARRAY_KEYS = ['history', 'family', 'needs'] as const;

type ConsultationRow = Record<string, string | string[] | number | null>;

const readText = (answers: Answers, key: string): string | null => {
  const value = answers[key];
  if (typeof value !== 'string') return null;
  const text = value.trim();
  return text ? text : null;
};

const readArray = (answers: Answers, key: string): string[] => {
  const value = answers[key];
  if (!Array.isArray(value)) return [];
  return value.filter((item) => typeof item === 'string' && item.trim() !== '');
};

export function buildConsultationRow(
  answers: Answers,
  evaluation: Evaluation,
): ConsultationRow {
  const row: ConsultationRow = {};

  TEXT_KEYS.forEach((key) => {
    row[key] = readText(answers, key);
  });

  ARRAY_KEYS.forEach((key) => {
    row[key] = readArray(answers, key);
  });

  row.total_score = evaluation.totalScore;
  row.rated_count = evaluation.ratedCount;
  row.severe_count = evaluation.severeCount;
  row.level_title = evaluation.levelTitle;
  row.focus_summary = evaluation.focus.map((item) => `${item.label}-${item.level}`).join('、');

  const cleanAnswers: Record<string, string | string[]> = {};
  Object.keys(answers).forEach((key) => {
    const value = answers[key];
    if (Array.isArray(value)) {
      if (value.length) cleanAnswers[key] = value;
      return;
    }
    if (typeof value === 'string' && value.trim()) cleanAnswers[key] = value.trim();
  });
  row.answers = JSON.stringify(cleanAnswers);

  return row;
}